import { render, staticRenderFns } from "./BannerTest2.vue?vue&type=template&id=802104ae&scoped=true&"
import script from "./BannerTest2.vue?vue&type=script&lang=js&"
export * from "./BannerTest2.vue?vue&type=script&lang=js&"
import style0 from "./BannerTest2.vue?vue&type=style&index=0&id=802104ae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "802104ae",
  null
  
)

export default component.exports